import React from 'react';
import styled, { css } from 'styled-components';
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';

import { Box, Flex, Grid } from './UIKit/system';
import Container from './container';
import SectionTitle from './section-title';
import SectionSubtitle from './section-subtitle';
import Button from './button';
import { withResponsiveContext } from './responsive';
import LazyImage from './lazy-image';
import Icon from './icon';
import mq from '../utils/mq';

const StyledSectionCTA = styled(Box)`
  position: relative;
  overflow: hidden;

  .parallax-outer,
  .parallax-inner {
    height: 100%;
    width: 100%;
  }

  .parallax-outer {
    position: absolute;
    left: 0;
    top: 0;
  }
`;

const BackgroundImage = styled(LazyImage)`
  position: absolute !important;
  left: 0;
  right: 0;
  top: -30px;
  bottom: -30px;
`;

const CtaContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;

  ${mq.mobile(css`
    flex-direction: column;
  `)}
`;

function SectionCTA({
  desktopBackground,
  mobileBackground,
  ctaLink,
  ctaText,
  subtitle,
  title,
  isDesktopOrTablet,
  secondLink,
  addBorderRadius,
  icon,
  slim
}) {
  const hasSecondLink = !!secondLink?.to;

  return (
    <StyledSectionCTA
      as={'section'}
      py={slim ? 64 : 156}
      backgroundColor={'#111'}
      color={'white'}
      backgroundSize="cover"
      backgroundPosition="center"
      borderRadius={
        addBorderRadius ? 'var(--Radius-Radius-3, 16px)' : undefined
      }
    >
      <ParallaxProvider>
        <Parallax y={[-8, 8]}>
          <BackgroundImage
            fluid={isDesktopOrTablet ? desktopBackground : mobileBackground}
          />
        </Parallax>
      </ParallaxProvider>
      <Container relative>
        <Flex
          justifyContent={'center'}
          flexDirection={'column'}
          alignItems={'center'}
        >
          {icon && <Icon name={icon} mb={32} />}
          <SectionTitle mb={[15]} fontSize={[36, 28, 38, 42]}>
            {title}
          </SectionTitle>
          <SectionSubtitle
            mb={[48]}
            fontSize={[18, 20, 20, 20]}
            textAlign={'center'}
          >
            {subtitle}
          </SectionSubtitle>
          <CtaContainer>
            <Button to={ctaLink} inDarkBlock={true} fitContentWidth>
              {ctaText}
            </Button>
            {hasSecondLink && (
              <Button to={secondLink.to} whiteInDark fitContentWidth>
                {secondLink.title}
              </Button>
            )}
          </CtaContainer>
        </Flex>
      </Container>
    </StyledSectionCTA>
  );
}

export default withResponsiveContext(SectionCTA);
